import styles from "./campain.module.css";
import { useState } from "react";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import Modal from "./modal/Modal";
import DelModal from "./modal/DelModal";
import BoxClue from "./BoxClue";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import Filter from "./modal/Filter";
import AddCampain from "./modal/AddCampain";
const ClueManagement = () => {
  const [img, setimg] = useState("");
  const [selectedItem, setSelectedItem] = useState(1);
  const [customers, setCustomers] = useState([
    {
      id: "1215",
      title: "کمپین ویژه",
      name: "مریم مقدم",
      mobile: "09220431517",
      lastStatus: "ارسال لب تاب",
      registerTime: "1400/2/2",
      startTime: "1400/2/2",
      endTime: "1400/2/2",
      resultStatus: "",
    },
    {
      id: "1215",
      title: "کمپین ویژه",
      name: "مریم مقدم",
      mobile: "09220431517",
      lastStatus: "ارسال لب تاب",
      registerTime: "1400/2/2",
      startTime: "1400/2/2",
      endTime: "1400/2/2",
      resultStatus: "",
    },
    {
      id: "1215",
      title: "کمپین ویژه",
      name: "مریم مقدم",
      mobile: "09220431517",
      lastStatus: "ارسال لب تاب",
      registerTime: "1400/2/2",
      startTime: "1400/2/2",
      endTime: "1400/2/2",
      resultStatus: "",
    },
    {
      id: "1215",
      title: "کمپین ویژه",
      name: "مریم مقدم",
      mobile: "09220431517",
      lastStatus: "ارسال لب تاب",
      registerTime: "1400/2/2",
      startTime: "1400/2/2",
      endTime: "1400/2/2",
      resultStatus: "",
    },
    {
      id: "1215",
      title: "کمپین ویژه",
      name: "مریم مقدم",
      mobile: "09220431517",
      lastStatus: "ارسال لب تاب",
      registerTime: "1400/2/2",
      startTime: "1400/2/2",
      endTime: "1400/2/2",
      resultStatus: "",
    },
  ]);
  const deleteHandler = (id) => {
    const filterItem = customers.filter((p) => p.id !== id);
    setCustomers(filterItem);
  };

  const changeHandlerDaste = (option) => {
    setCustomers((prev) => {
      let temp = [...prev];
      temp[selectedItem].barchasb = option;
      return [...temp];
    });
  };
  const optionDasteBandi = [
    { label: "باشگاه مشتریان ", value: "custom" },
    { label: " کاربر ویژه", value: "spcial" },
    { label: " کاربر عادی", value: "normal" },
  ];

  return (
    <div className="container w-100">
      <div>
        <button
          className="btn btn-success m-3"
          id=""
          data-bs-toggle="modal"
          data-bs-target="#FilterModal"
        >
          <FaFilter /> فیلتر
        </button>
        <button className="btn btn-danger m-3" id="">
          <FaTrashAlt /> حذف فیلتر
        </button>
        <button
          className="btn btn-secondary m-3"
          id=""
          data-bs-toggle="modal"
          data-bs-target="#exampleModalAdd"
        >
          <AiOutlinePlus /> جدید
        </button>
      </div>
      {customers.map((item, index) => {
        return (
          <div>
            <BoxClue
              item={item}
              key={item.id}
              customers={customers}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              setCustomers={setCustomers}
              index={index}
              deleteHandler={() => deleteHandler(item.id)}
            />
          </div>
        );
      })}
      <div className="d-flex justify-content-center mt-4">
        <AiFillLeftCircle className={styles.circl} />
      </div>
      <Filter />
      <AddCampain />
      <Modal
        index={selectedItem}
        customers={customers}
        optionDasteBandi={optionDasteBandi}
        changeHandlerDaste={changeHandlerDaste}
        EditUser={setCustomers}
      />
      {/* <!--Modal Trash--> */}
      <DelModal
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      {/* <!--Modal Edit--> */}
    </div>
  );
};

export default ClueManagement;
